var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 25,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22656 13.316V13.9071C5.22656 14.8824 6.17748 15.6804 7.33972 15.6804C8.50195 15.6804 9.45287 14.8824 9.45287 13.9071V12.5278",
    stroke: "#50618B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38839 13.3159H14.46V12.1029C14.46 11.2635 14.1058 10.4849 13.526 9.89374L12.2057 8.61852C11.5937 8.0274 11.2725 7.2495 11.2725 6.40934V4.91658C11.2725 3.01872 9.69353 1.49365 7.72998 1.49365C5.76559 1.49365 4.18833 3.01872 4.18833 4.91658V6.40934C4.18833 7.2495 3.86629 8.0274 3.25347 8.61852L1.93402 9.89374C1.35417 10.4849 1 11.2635 1 12.1029V13.3159H6.07158",
    stroke: "#50618B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsIcon);
export default __webpack_public_path__ + "static/media/Alerts_Icon.c2e3e96c8ea36b8eeec3d894b82d3497.svg";
export { ForwardRef as ReactComponent };